module.exports = __webpack_public_path__ + "img/login.1a4c1db1.png";